import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    loading: false,
    postRes: null,
    getRes: null,
    getByIdRes: null,
    getByPatientRes: null,
    updateStatusRes: null,
    cancelRes: null,
    addTestsRes: null,
    cancelTestRes: null,
    editOrderRes: null,
    bulkReleaseRes: null,
};

const slice = createSlice({
    name: 'labOrder',
    initialState,
    reducers: {
        postLabOrderRequest: (state) => { state.loading = true; },
        postLabOrderSuccess: (state, action) => { state.loading = false; state.postRes = action.payload; },
        postLabOrderFailure: (state, action) => { state.loading = false; state.postRes = action.payload; },
        resetPostLabOrder: (state) => { state.postRes = null; },

        getLabOrderRequest: (state) => { state.loading = true; },
        getLabOrderSuccess: (state, action) => { state.loading = false; state.getRes = action.payload; },
        getLabOrderFailure: (state, action) => { state.loading = false; state.getRes = action.payload; },
        resetGetLabOrder: (state) => { state.getRes = null; },

        getLabOrderByIdRequest: (state) => { state.loading = true; },
        getLabOrderByIdSuccess: (state, action) => { state.loading = false; state.getByIdRes = action.payload; },
        getLabOrderByIdFailure: (state, action) => { state.loading = false; state.getByIdRes = action.payload; },
        resetGetLabOrderById: (state) => { state.getByIdRes = null; },

        getLabOrderByPatientRequest: (state) => { state.loading = true; },
        getLabOrderByPatientSuccess: (state, action) => { state.loading = false; state.getByPatientRes = action.payload; },
        getLabOrderByPatientFailure: (state, action) => { state.loading = false; state.getByPatientRes = action.payload; },
        resetGetLabOrderByPatient: (state) => { state.getByPatientRes = null; },

        updateLabOrderStatusRequest: (state) => { state.loading = true; },
        updateLabOrderStatusSuccess: (state, action) => { state.loading = false; state.updateStatusRes = action.payload; },
        updateLabOrderStatusFailure: (state, action) => { state.loading = false; state.updateStatusRes = action.payload; },
        resetUpdateLabOrderStatus: (state) => { state.updateStatusRes = null; },

        cancelLabOrderRequest: (state) => { state.loading = true; },
        cancelLabOrderSuccess: (state, action) => { state.loading = false; state.cancelRes = action.payload; },
        cancelLabOrderFailure: (state, action) => { state.loading = false; state.cancelRes = action.payload; },
        resetCancelLabOrder: (state) => { state.cancelRes = null; },

        addTestsRequest: (state) => { state.loading = true; },
        addTestsSuccess: (state, action) => { state.loading = false; state.addTestsRes = action.payload; },
        addTestsFailure: (state, action) => { state.loading = false; state.addTestsRes = action.payload; },
        resetAddTests: (state) => { state.addTestsRes = null; },

        cancelTestRequest: (state) => { state.loading = true; },
        cancelTestSuccess: (state, action) => { state.loading = false; state.cancelTestRes = action.payload; },
        cancelTestFailure: (state, action) => { state.loading = false; state.cancelTestRes = action.payload; },
        resetCancelTest: (state) => { state.cancelTestRes = null; },

        editOrderRequest: (state) => { state.loading = true; },
        editOrderSuccess: (state, action) => { state.loading = false; state.editOrderRes = action.payload; },
        editOrderFailure: (state, action) => { state.loading = false; state.editOrderRes = action.payload; },
        resetEditOrder: (state) => { state.editOrderRes = null; },

        bulkReleaseLabOrderRequest: (state) => { state.loading = true; },
        bulkReleaseLabOrderSuccess: (state, action) => { state.loading = false; state.bulkReleaseRes = action.payload; },
        bulkReleaseLabOrderFailure: (state, action) => { state.loading = false; state.bulkReleaseRes = action.payload; },
        resetBulkReleaseLabOrder: (state) => { state.bulkReleaseRes = null; },
    }
});

export const {
    postLabOrderRequest, postLabOrderSuccess, postLabOrderFailure, resetPostLabOrder,
    getLabOrderRequest, getLabOrderSuccess, getLabOrderFailure, resetGetLabOrder,
    getLabOrderByIdRequest, getLabOrderByIdSuccess, getLabOrderByIdFailure, resetGetLabOrderById,
    getLabOrderByPatientRequest, getLabOrderByPatientSuccess, getLabOrderByPatientFailure, resetGetLabOrderByPatient,
    updateLabOrderStatusRequest, updateLabOrderStatusSuccess, updateLabOrderStatusFailure, resetUpdateLabOrderStatus,
    cancelLabOrderRequest, cancelLabOrderSuccess, cancelLabOrderFailure, resetCancelLabOrder,
    addTestsRequest, addTestsSuccess, addTestsFailure, resetAddTests,
    cancelTestRequest, cancelTestSuccess, cancelTestFailure, resetCancelTest,
    editOrderRequest, editOrderSuccess, editOrderFailure, resetEditOrder,
    bulkReleaseLabOrderRequest, bulkReleaseLabOrderSuccess, bulkReleaseLabOrderFailure, resetBulkReleaseLabOrder,
} = slice.actions;

export default slice.reducer;
